import React from 'react';
import { Row, Col, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DataContext } from './DataContextProvider.js';

export default function Totals({ filters, dataAvailable }) {
  const dataContext = React.useContext(DataContext);
  /*
  const dataAvailable = dataContext.getDateData() /*{
    start: dataContext.start,
    end: dataContext.end,
    interval: dataContext.interval,
    filters: filters,
    split: dataContext.split,
  });*/

  let totalUsersLastYear = 0;
  let totalSessions = 0;
  let totalPageViews = 0;
  let totalPageViewsLastYear = 0;
  let totalSignups = 0;
  let totalSignupsLastYear = 0;
  let totalRate = 0;
  let totalRateLastYear = 0;
  if (dataAvailable) {
    totalUsersLastYear = dataContext.dateData.lastYear.results.reduce((a, b) => a + b[1], 0);
    totalSessions = dataContext.dateData.current.results.reduce((a, b) => a + b[2], 0);
    totalPageViews = dataContext.dateData.current.results.reduce((a, b) => a + b[3], 0);
    totalPageViewsLastYear = dataContext.dateData.lastYear.results.reduce((a, b) => a + b[3], 0);
    totalSignups = dataContext.dateData.current.results.reduce((a, b) => a + b[7], 0);
    totalSignupsLastYear = dataContext.dateData.lastYear.results.reduce((a, b) => a + b[7], 0);
    totalRate = totalSessions > 0 ? parseInt(10000 * totalSignups / totalSessions + 0.5) / 100 : 0;
    totalRateLastYear = totalUsersLastYear > 0 ? parseInt(10000 * totalSignupsLastYear / totalUsersLastYear) / 100 : 0;
  }

  const yoy = (thisYear, lastYear) => lastYear > 0 ? parseInt((thisYear / lastYear - 1) * 10000) / 100 : undefined;
  let totalPageViewsYoy = yoy(totalPageViews, totalPageViewsLastYear)
  let totalSignupsYoy = yoy(totalSignups, totalSignupsLastYear)
  let totalRateYoy = yoy(totalRate, totalRateLastYear)

  const tooltip = (msg, props) => {
    return (
      <Tooltip id="button-tooltip" {...props}>
        {msg}
      </Tooltip>
    );
  }

  const pageViewsTooltip = "Number of individual visits to a page.";
  const signupsTooltip = "Number of sessions in which the user clicked the sign up call to action button.";
  const conversionRateTooltip = "The percentage of sessions in which the user clicked the sign up call to action button.";

  return (
    <Row className="totals">
    { dataAvailable ?
      <>
        <Col className="card total page-views-icon">
          <h1>{totalPageViews.toLocaleString()}</h1>
          {totalPageViewsYoy !== undefined ?
            <p>vs {totalPageViewsLastYear.toLocaleString()} <span className={totalPageViewsYoy >= 0 ? 'yoy-up' : 'yoy-down'}>{totalPageViewsYoy}% YoY</span></p>
          :
            <p>N/A</p>
          }
          <hr />
          <h2>
            Page views &nbsp;
            <OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={tooltip.bind(null, pageViewsTooltip)}>
              <Badge pill bg="secondary"> ? </Badge>
            </OverlayTrigger>
          </h2>
        </Col>
        <Col className="card total signups-icon">
          <h1>{totalSignups.toLocaleString()}</h1>
          {totalSignupsYoy !== undefined ?
            <p>vs {totalSignupsLastYear.toLocaleString()} <span className={totalSignupsYoy >= 0 ? 'yoy-up' : 'yoy-down'}>{totalSignupsYoy}% YoY</span></p>
          :
            <p>N/A</p>
          }
          <hr />
          <h2>
            Signups &nbsp;
            <OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={tooltip.bind(null, signupsTooltip)}>
              <Badge pill bg="secondary"> ? </Badge>
            </OverlayTrigger>
          </h2>
        </Col>
        <Col className="card total conversion-rate-icon">
          <h1>{totalRate.toLocaleString()}</h1>
          {totalRateYoy !== undefined ?
            <p>vs {totalRateLastYear.toLocaleString()} <span className={totalRateYoy >= 0 ? 'yoy-up' : 'yoy-down'}>{totalRateYoy}% YoY</span></p>
          :
            <p>N/A</p>
          }
          <hr />
          <h2>
            Conversion Rate &nbsp;
            <OverlayTrigger placement="bottom" delay={{ show: 250, hide: 400 }} overlay={tooltip.bind(null, conversionRateTooltip)}>
              <Badge pill bg="secondary"> ? </Badge>
            </OverlayTrigger>
          </h2>
        </Col>
      </>
    :
      <>
        <Col className="card total page-views-icon" />
        <Col className="card total signups-icon" />
        <Col className="card total conversion-rate-icon" />
      </>
    }
    </Row>
  );
}
